module.exports = __webpack_public_path__ + "static/media/facebook.25be9c4f.png";